import CryptoJS from 'crypto-js'

const secretKey = 'abdf14b3f5c71b25d6929c7971abba848ab56fd3f8a1a0ead82bd121238524eb22e5b159a2be081145bd1b513257d14ffc368a7b4e3a16871bb0c6837fadfae9'

export const encrypt = (plainText: string) => {
    const base64 = CryptoJS.AES.encrypt(plainText, secretKey).toString();

    // Base64 → Base64URL safe
    return base64
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
};

export const decrypt = (cipherText: string) => {
    // Base64URL safe → Base64
    let base64 = cipherText
        .replace(/-/g, "+")
        .replace(/_/g, "/");

    // restore padding
    while (base64.length % 4) {
        base64 += "=";
    }

    const bytes = CryptoJS.AES.decrypt(base64, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
};